import React from 'react';
import { NumericFormat } from 'react-number-format';
import { Form } from 'react-bootstrap';

interface CurrencyInputProps {
  value: number | string;
  onChange: (value: number) => void;
  label: string;
  placeholder?: string;
  required?: boolean;
  min?: number;
  isInvalid?: boolean;
  errorMessage?: string;
}

const CurrencyInput: React.FC<CurrencyInputProps> = ({
  value,
  onChange,
  label,
  placeholder,
  required = false,
  min = 0,
  isInvalid = false,
  errorMessage,
}) => {
  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    // Select all text when input is focused for better UX
    e.target.select();
  };

  return (
    <Form.Group className="mb-2">
      <Form.Label className="mb-1" style={{ fontSize: '0.85rem' }}>
        {label}
        {required && <span className="text-danger">*</span>}
      </Form.Label>
      <NumericFormat
        value={value}
        onValueChange={(values) => {
          onChange(values.floatValue || 0);
        }}
        onFocus={handleFocus}
        thousandSeparator=","
        prefix="R "
        decimalScale={2}
        fixedDecimalScale
        allowNegative={false}
        className={`form-control ${isInvalid ? 'is-invalid' : ''}`}
        placeholder={placeholder}
      />
      {isInvalid && errorMessage && (
        <div className="invalid-feedback d-block">{errorMessage}</div>
      )}
    </Form.Group>
  );
};

export default CurrencyInput;
